import React from 'react';
import PropTypes from 'prop-types';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { PopoverItem } from 'site-modules/shared/components/popover-item/popover-item';

export function AuthorTooltip({
  title = null,
  aboutAuthor = null,
  name,
  suffix = null,
  trackingParent = null,
  trackingSubaction = null,
}) {
  return (
    <PopoverItem
      iconClassName="medium"
      screenReaderTooltipLabel={name}
      openTrackingParams={
        trackingParent
          ? { subaction_name: trackingSubaction || 'view_author_tooltip', creative_id: trackingParent, value: name }
          : undefined
      }
    >
      {!!title && <div className="fw-bold mb-0_25">{title}</div>}
      {aboutAuthor ? (
        <ContentFragment>{aboutAuthor}</ContentFragment>
      ) : (
        `${name} is an automotive journalist at Edmunds.`
      )}
      {suffix}
    </PopoverItem>
  );
}

AuthorTooltip.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  aboutAuthor: PropTypes.string,
  suffix: PropTypes.node,
  trackingParent: PropTypes.string,
  trackingSubaction: PropTypes.string,
};
